import { Custom_Display_Image, Custom_Display_Type_ENUM } from '@/utils/uiHelper';

let timer: NodeJS.Timeout;
export const setConsumerDisplayImage = (type: keyof typeof Custom_Display_Image) => {
  clearTimeout(timer);
  window.__POS_Device__.setConsumerDisplayImage(Custom_Display_Image[type]);
  // 如果切换到了企微卡片，5分钟后自动切回价目表
  // if (type === Custom_Display_Type_ENUM.CARD) {
  //   timer = setTimeout(() => {
  //     setConsumerDisplayImage(Custom_Display_Type_ENUM.PRICE);
  //   }, 1000 * 60 * 5);
  // }
};
